module.exports = __webpack_public_path__ + "static/media/game-setup-on.ee9499fd.png";